import _ from 'lodash'
import React, {useContext} from 'react'
import Description from '../Description'
import FeedContext from '../FeedContext'
import {renderIf} from "../../../views/Shared";

export const DetailAskContent = () => {
  const {
    item,
    type,
    photos,
    embed_data,
    content_data,
    poll,
    description,
    mentions,
  } = useContext(FeedContext)

  return (
    <div className="space-y-3 overflow-hidden">
      <div className="flex flex-col">
        <div className="text-base mb-2 mt-1">
          {_.get(item, 'title')}
        </div>
        {renderIf(
            description,
            <div className="mb-1 border-l-2 border-color-300 background-100 px-3 py-2 rounded-r-lg text-sm text-color-200 italic">
              <Description type={type} mentions={mentions}>
                {description}
              </Description>
            </div>
        )}
      </div>
    </div>
  )
}
